import { render, staticRenderFns } from "./PremioEsp.vue?vue&type=template&id=10be99b9"
import script from "./PremioEsp.vue?vue&type=script&lang=js"
export * from "./PremioEsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports